import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReadOnlyField from '../../../../../common/components/ReadOnlyField';
import { LockIcon } from '../../../../../common/icons/redesignIcons';

import './RegLegalPerson.css';

// TODO verify codIstatComune
@inject('translationsStore', 'moveinStore')
@observer
export default class RegLegalPerson extends Component {
  render() {
    const { translationsStore, moveinStore } = this.props;
    return (
      <div className="RegLegalPerson">
        <div className="RegLegalPersonHeader">
          <span className="mv-section-title">{translationsStore.translate('registration.legalPerson.title')}</span>
          <span className="mv-chip">
            <LockIcon size={11} color="currentColor" />
            {translationsStore.translate('movein.stepCheckData.fromRegionChip')}
          </span>
        </div>
        <div className="RegLegalPersonFields">
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.ragioneSociale')} value={moveinStore.company.name} />
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.telefono')} value={moveinStore.company.phone} />
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.email')} value={moveinStore.company.email} />
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.partitaIva')} value={moveinStore.company.tax_code} />
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.provincia')} value={moveinStore.company.registered_office.province} />
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.comune')} value={moveinStore.company.registered_office.city} />
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.indirizzo')} value={moveinStore.company.registered_office.street} />
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.numCivico')} value={moveinStore.company.registered_office.building_number} />
          <ReadOnlyField label={translationsStore.translate('registration.legalPerson.cap')} value={moveinStore.company.registered_office.postcode} />
        </div>
      </div>
    );
  }
}
